import { connect } from 'react-redux';
import StartupUsers from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.startupUsers,
    literalsCommon: state.i18n.literals.common,
    user: state.session.user,
    startup: state.global.startup,
  };
}

export default connect(mapStateToProps)(StartupUsers);
